export var EPreferences;
(function (EPreferences) {
    EPreferences["Announcement"] = "ANNOUNCEMENT";
})(EPreferences || (EPreferences = {}));
